import { Button } from 'antd'
import dayjs from 'dayjs'
import { FC } from 'react'
import connect from '../../../../helpers/api/connect'
import useErrorModal from '../../../../hooks/api/use-error-modal'
import useSuccessModal from '../../../../hooks/api/use-success-modal'
import { userStorage } from '../../../../services/user-storage'
import { useUpdateRewindJobMutation } from '../../../../store/api/rewind-jobs-api'
import RewindJob, { RewindJobStatuses } from '../../../../types/api/rewind-job'

interface ActionsCellProps {
    rewindJob: RewindJob
}

const ActionsCell: FC<ActionsCellProps> = ({ rewindJob }) => {
    const [updateRewindJob, updateRewindJobState] = useUpdateRewindJobMutation()
    const needApprove =
        (rewindJob.rewind_queue_entries || []).length === 0 &&
        (rewindJob.jobStatus === RewindJobStatuses.Rewinding ||
            rewindJob.jobStatus === RewindJobStatuses.Cancelled) &&
        !rewindJob.approved_by

    const onApprove = async () => {
        const canceled = rewindJob.jobStatus === RewindJobStatuses.Cancelled

        await updateRewindJob({
            docId: rewindJob.documentId,
            body: {
                data: {
                    jobStatus: canceled ? RewindJobStatuses.Cancelled : RewindJobStatuses.Completed,
                    approved_by: connect(userStorage.get()),
                    approvedAt: dayjs().toISOString(),
                },
            },
        })
    }

    useErrorModal(updateRewindJobState, 'Ошибка обновления статуса')
    useSuccessModal(updateRewindJobState, 'Задание подтверждено')

    return (
        <>
            {needApprove && (
                <Button
                    type='primary'
                    loading={updateRewindJobState.isLoading}
                    onClick={onApprove}
                >
                    Подтвердить
                </Button>
            )}
        </>
    )
}

export default ActionsCell
